import type { CancellationFlow } from '../../../types/cancellation/cancellation-flow';

import useFeatureFlags from '@blueshift-ui/auth/dist/hooks/use-feature-flags';
import useNspContent from '@blueshift-ui/nsp/dist/hooks/use-nsp-content';

const FLOW_QUERY_FRAGMENT = `
steps {
  actionPanel {
    actionCards {
      actionButton {
        actionKey
        content
        iconKey
      }
      content {
        value
        blocks {
          __typename
          ... on SingleImageBlockRecord {
            id
            image {
              url
              alt
            }
          }
        }
      }
      headerColor
      header {
        value
      }
    }
    hasDowngradeOptions
    title {
      value
    }
  }
  benefitPanel {
    content {
      value
      blocks {
        __typename
        ... on SingleImageBlockRecord {
          id
          image {
            url
            alt
          }
        }
      }
    }
  }
}
flowId
name
`;

interface useCancellationFlowProps {
  cancellationReason?: string;
  userId?: string;
}

function useCancellationFlow({ cancellationReason, userId }: useCancellationFlowProps) {
  const { flags } = useFeatureFlags({
    context: {
      kind: 'multi',
      'application-flow-key': {
        key: cancellationReason,
      },
      user: {
        key: userId,
      },
    },
  });
  const flowId = flags['self-cancellation-flow-control'];
  const gql = String.raw;

  return useNspContent<CancellationFlow>({
    preview: true,
    query: gql`
    query queryCancellationFlows($targetFlowId: StringFilter!, $defaultFlowId: StringFilter!) {
      userFlow: allMembershipAccountCancellationFlows(filter: { flowId: $targetFlowId }) {
        ${FLOW_QUERY_FRAGMENT}
    },
      defaultFlow: allMembershipAccountCancellationFlows(filter: {flowId: $defaultFlowId}) {
        ${FLOW_QUERY_FRAGMENT}
    },
   }
    `,
    queryKey: [cancellationReason, userId, flowId],
    queryId: 'cancellationFlow',
    queryOptions: {
      select(response: any) {
        const data = response?.results?.[0]?.data;
        if (!data) {
          return null;
        }

        if (data.userFlow.length) {
          return data.userFlow[0];
        }

        if (data.defaultFlow.length) {
          return data.defaultFlow[0];
        }

        return null;
      },
    },
    variables: {
      targetFlowId: { eq: flowId },
      defaultFlowId: { eq: 'default' },
    },
  });
}

export default useCancellationFlow;
